module.exports = __webpack_public_path__ + "media/Video3.f4e3ce67.mp4";